import { msg } from '@lingui/core/macro'
import type { MessageDescriptor } from '@lingui/core'

export const Routes = {
  ROOT: '/',
  HOME: '/home',
  SUPER_ADMIN: '/superAdmin',
  GRUPOS: '/grupos',
  GRUPO_NOVO: '/grupos/novo',
  GRUPO: '/grupos/:id',
  DEALER_NOVO: '/dealers/novo',
  DEALER: '/dealers/:id',
  DEALERS: '/dealers',
  USUARIOS: '/usuarios',
  USUARIO_NOVO: '/usuarios/novo',
  USUARIO: '/usuarios/:id',
  AUSENCIA_TEMPORARIA: '/usuarios/:id/ausencia-temporaria',
  GRUPOS_USUARIOS: '/gruposUsuarios',
  GRUPO_USUARIOS_NOVO: '/gruposUsuarios/novo',
  GRUPO_USUARIOS: '/gruposUsuarios/:id',
  AUDITORIA: '/auditoria/:id/:tipo',
  BIBLIOTECA_VIRTUAL_PASTA: '/biblioteca/:idPasta',
  BIBLIOTECA_VIRTUAL: '/biblioteca',
  COMUNICADOS_NOVO: '/comunicados/novo',
  COMUNICADO_EDICAO: '/comunicados/editar/:id',
  COMUNICADO_ERRATA: '/comunicados/errata/:id',
  COMUNICADO_ENVIO_VISUALIZACAO: '/comunicados/visualizarEnvio/:id',
  COMUNICADO_VISUALIZACAO: '/comunicados/visualizar/:id',
  COMUNICADO_DASHBOARD: '/comunicados/dashboard/:id',
  COMUNICADOS: '/comunicados',
  MINHA_CONTA: '/minha-conta',
  SLIDES: '/slides',
  SLIDE_NOVO: '/slides/novo',
  SLIDE_EDICAO: '/slides/editar/:id',
  ANUNCIO_NOVO: '/anuncios/novo',
  ANUNCIO_EDICAO: '/anuncios/editar/:id',
  ANUNCIOS: '/anuncios',
  NOTIFICACOES: '/notificacoes',
  NOTIFICACOES_GENERICAS: '/notificacoesGenericas',
  NOTIFICACAO_NOVA: '/notificacoesGenericas/nova/:tipo',
  NOTIFICACAO_EDICAO: '/notificacoesGenericas/editar/:tipo/:id',
  IMPORTAR_USUARIOS: '/importarUsuarios',
  RELATORIO_PAGE: '/relatorio/:slug',
  DOWNLOAD_PAGE: '/download/:id'
}

export const RouteMeta: { path: string; label: MessageDescriptor }[] = [
  { path: '/', label: msg`Início` },
  { path: '/home', label: msg`Início` },
  { path: '/superAdmin', label: msg`Super Admin` },
  { path: '/grupos', label: msg`Grupo de Dealers` },
  { path: '/grupos/novo', label: msg`Novo Grupo de Dealers` },
  { path: '/grupos/:id', label: msg`Editar Grupo de Dealers` },
  { path: '/dealers/novo', label: msg`Novo Dealer` },
  { path: '/dealers/:id', label: msg`Editar Dealer` },
  { path: '/dealers', label: msg`Dealers` },
  { path: '/usuarios', label: msg`Usuários` },
  { path: '/usuarios/novo', label: msg`Novo Usuário` },
  { path: '/usuarios/:id', label: msg`Editar Usuário` },
  {
    path: '/usuarios/:id/ausencia-temporaria',
    label: msg`Ausências Temporárias`
  },
  { path: '/gruposUsuarios', label: msg`Grupo de Usuários` },
  {
    path: '/gruposUsuarios/novo',
    label: msg`Novo Grupo de Usuários`
  },
  {
    path: '/gruposUsuarios/:id',
    label: msg`Editar Grupo de Usuários`
  },
  { path: '/auditoria/:id/:tipo', label: msg`Auditoria` },
  {
    path: '/biblioteca/:idPasta',
    label: msg`Pasta`
  },
  { path: '/biblioteca', label: msg`Biblioteca Virtual` },
  { path: '/comunicados/novo', label: msg`Novo Comunicado` },
  {
    path: '/comunicados/editar/:id',
    label: msg`Editar Comunicado`
  },
  {
    path: '/comunicados/errata/:id',
    label: msg`Criar Errata`
  },
  {
    path: '/comunicados/visualizarEnvio/:id',
    label: msg`Visualizar Envio`
  },
  {
    path: '/comunicados/visualizar/:id',
    label: msg`Visualizar Comunicado`
  },
  {
    path: '/comunicados/dashboard/:id',
    label: msg`Dashboard de Comunicado`
  },
  { path: '/comunicados', label: msg`Comunicados` },
  { path: '/minha-conta', label: msg`Minha Conta` },
  { path: '/slides', label: msg`Slides` },
  { path: '/slides/novo', label: msg`Novo Slide` },
  { path: '/slides/editar/:id', label: msg`Editar Slide` },
  { path: '/anuncios/novo', label: msg`Novo Anúncio` },
  { path: '/anuncios/editar/:id', label: msg`Editar Anúncio` },
  { path: '/anuncios', label: msg`Anúncios` },
  { path: '/notificacoes', label: msg`Notificações` },
  {
    path: '/notificacoesGenericas',
    label: msg`Notificações Genéricas`
  },
  {
    path: '/notificacoesGenericas/nova/:tipo',
    label: msg`Nova Notificação`
  },
  {
    path: '/notificacoesGenericas/editar/:tipo/:id',
    label: msg`Editar Notificação`
  },
  { path: '/importarUsuarios', label: msg`Importar Usuários` },
  { path: '/relatorio/:slug', label: msg`Relatório` }
]
